import { z } from 'zod';

import { apiClient } from './client';

const shopItemSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  kind: z.string().min(1),
  contentId: z.string().nullish(),
  effectQty: z.number().int().nonnegative().optional(),
  quantity: z.number().int().nonnegative().optional(),
  effect: z.string().optional(),
  price: z.number().int().nonnegative(),
  imageUrl: z.string().optional(),
  enabled: z.boolean(),
});
export type ShopItem = z.infer<typeof shopItemSchema>;

export const shopApi = {
  async list(): Promise<ShopItem[]> {
    return z
      .array(shopItemSchema)
      .parse(await apiClient.shop.list())
      .map((item) => ({ ...item, effectQty: item.quantity ?? item.effectQty }));
  },
  purchase: (itemId: string, actionId?: string) =>
    apiClient.shop.purchase({ itemId, actionId }, actionId ? { idempotencyKey: actionId } : undefined),
};
